module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/cognito-identity-2014-06-30.paginators.json
// module id = ./node_modules/aws-sdk/apis/cognito-identity-2014-06-30.paginators.json
// module chunks = vendor